import apiFetch from '../apiFetch'
export default function (order, dossierId, token, lastAccessDate) {
  return apiFetch({ endPoint: `order?DossierId=${dossierId}`, method: 'POST', body: order, token: token, lastAccessDate })
}
